// For full API documentation, including code examples, visit http://wix.to/94BuAAs
import wixWindow from 'wix-window';
import wixLocation from 'wix-location';

$w.onReady(function () {
	//TODO: write your page related code here...
	if(wixWindow.formFactor === "mobile" || wixWindow.formFactor === "Mobile" || wixWindow.formFactor === "tablet" || wixWindow.formFactor === "Tablet"){
		
		if(wixWindow.formFactor === "mobile" || wixWindow.formFactor === "Mobile"){
			$w('#columnStrip1').show();
		}	
		wixLocation.to('/mobile');
  } else
	wixLocation.to('/desktop');
});
